import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReceipt1 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "receipt-1" }),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.5,
			y1: 4.5,
			x2: 9.75,
			y2: 4.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 8.25,
			x2: 14.25,
			y2: 8.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 12,
			x2: 14.25,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 15.75,
			x2: 14.25,
			y2: 15.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 8.25,
			y1: 19.5,
			x2: 11.25,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.5.75H21a1.5,1.5,0,0,1,1.5,1.5V6.5a1,1,0,0,1-1,1H18a0,0,0,0,1,0,0V2.25A1.5,1.5,0,0,1,19.5.75Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25.75H7.5a3,3,0,0,0-3,3v15c0,3-1.5,3.876-3,4.5h12a4.5,4.5,0,0,0,4.5-4.5V7.5"
		})
	]
});
export default SvgReceipt1;
